import styled from "@emotion/styled";
import DoneIcon from "@mui/icons-material/Done";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { shouldForwardProp } from "../../../../common/Common.style";
import theme from "../../../../theme";
import { HHNTheme } from "hhn-commons";
import { Error } from "@mui/icons-material";
import { Typography } from "@mui/material";

type MessageStatusProps = {
  isMessageRead?: boolean;
};

export const MessageDeliveryStatusBox = styled("span", {
  shouldForwardProp: prop =>
    shouldForwardProp<MessageStatusProps>(["isMessageRead"], prop),
})<MessageStatusProps>(({ isMessageRead }) => ({
  display: "flex",
  alignItems: "center",
  gap: 3,
  color: isMessageRead
    ? `${theme.palette.primary.main}`
    : `${theme.palette.secondary.main}`,
}));

export const MessageStatusBox = styled("span")`
  display: flex;
  align-items: center;
  gap: 3px;
  position: absolute;
  left: 0;
  color: ${theme.palette.secondary.main};
`;

export const MessageSentIcon = styled(DoneIcon)`
  font-size: 17px;
`;

export const MessageReadDeliveredIcon = styled(DoneAllIcon)`
  font-size: 17px;
`;

export const MessageFailedIcon = styled(Error)`
  font-size: 17px;
  /* The brand's softer red rather than MUI's stock error colour. Fine for an
     icon at 3.9:1, which clears the 3:1 bar for non-text graphics; the action
     text beside it needs a darker red to clear 4.5:1. */
  color: ${HHNTheme.error};
`;

export const MessageStatusText = styled(Typography)`
  font-size: 13px;
  font-style: italic;
  margin-left: 4px;
`;

export const Dots = styled.span`
  opacity: 0.7;
  transition: opacity 0.3s;
  font-weight: 600;
  letter-spacing: 1;
`;
